import { setupDynamicBanner } from "banco-website/dynamic_banner";
import { Typewriter } from "banco-website/typewriter";
import "banco/classes/SmartlookSupport";
import "../lib/navbar";

const setupTypewriter = (): void => {
  document.addEventListener("DOMContentLoaded", () => {
    const el = document.getElementById("typewriter-homepage");
    if (el) {
      const typewriter = new Typewriter(el, {
        words: ["Friendly.", "Supportive.", "Helpful.", "Efficient."],
        speed: 80,
        iterations: -1,
        pause: 500
      });
      typewriter.run();
    }
  });
};

setupDynamicBanner();
setupTypewriter();
